import accountDetails from './accountDetails'
import activeProfile from './activeProfile'
import locker from './locker'
import modal from './modal'
import onboarding from './onboarding'
import user from './user'

// Redux Form
import { reducer as formReducer } from 'redux-form'

export default {
  accountDetails,
  activeProfile,
  modal,
  locker,
  onboarding,
  user,
  form: formReducer
}


// WEBPACK FOOTER //
// ./src/reducers/index.js